import {CommonMessages} from '../common.messages';

export const PanelReferralPayoutsMessages = {
    GetPayoutQueueFailed: {
        key: 'GetPayoutQueueFailed',
        message: 'Error while communication with the server. Unable to get referral payout requests.'
    },
    NotFoundExportData: {
        key: 'NotFoundExportData',
        message: 'Error while communication with the server. Can\'t find data to export.'
    },
    WrongDateTo: {
        key: 'WrongDateTo',
        message: 'Date To must be greater than Date From'
    },
    ...CommonMessages
};
